import React from 'react';

export default function Fedex({ ...props }) {
  return (
    <svg
      width="121"
      height="37"
      viewBox="0 0 121 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M110.226 23.9131L120.22 12.6818H108.52L104.451 17.3318L100.233 12.6818H77.9763V9.68184H88.4951V0.663086H60.1451V14.8193H60.0513C58.2513 12.7568 56.0201 12.0443 53.4138 12.0443C48.0888 12.0443 44.0763 15.6818 42.6701 20.4631C39.2951 9.32558 24.4076 9.66308 19.8138 17.8381V13.3006H9.53882V8.38808H20.7888V0.681833H0.351318V35.2568H9.53882V20.7256H18.7076C18.4263 21.7943 18.2763 22.9381 18.2763 24.1381C18.2763 37.8443 37.5138 41.2756 42.6888 28.5818H34.8138C32.0576 32.5006 26.2263 30.2506 26.2263 25.8443H42.2576C42.9513 31.5631 47.3951 36.5131 53.5263 36.5131C56.1701 36.5131 58.5888 35.2193 60.0701 33.0256H60.1638V35.2568H99.9513L104.095 30.5693L108.276 35.2568H120.351L110.226 23.9131ZM26.4701 20.8006C27.6138 15.8693 34.2888 16.0006 35.1888 20.8006H26.4701ZM55.2326 29.9693C48.7451 29.9693 48.8576 18.1943 55.2326 18.1943C61.3451 18.1943 61.7013 29.9693 55.2326 29.9693ZM86.6951 33.5506H68.9951V2.33183H86.8076V7.99434H76.2888V14.3506H86.6951V19.6193H76.1763V28.0006H86.6951V33.5506ZM78.0888 26.0881V21.5131H88.6076V13.2631L98.1138 23.9506L88.6076 34.6381V26.0881H78.0888ZM104.076 28.0193L99.1826 33.5506H92.0388L100.589 23.9506L92.0388 14.3506H99.4826L104.47 19.8443L109.27 14.3506H116.489L107.976 23.9131L116.601 33.5506H109.008L104.076 28.0193Z"
        fill="#10284B"
      />
    </svg>
  );
}
